import { render, staticRenderFns } from "./Presets.vue?vue&type=template&id=04be106f&scoped=true"
import script from "./Presets.vue?vue&type=script&lang=js"
export * from "./Presets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04be106f",
  null
  
)

export default component.exports